// src/admin/ViewApplication.js

import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";

export default function ViewApplication() {
  const [applications, setApplications] = useState([]);
  const [filteredApplications, setFilteredApplications] =
    useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  // =========================================
  // FETCH APPLICATIONS
  // =========================================
  const fetchApplications = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/api/admin/applications`
      );

      if (res.data.success) {
        setApplications(res.data.applications);
        setFilteredApplications(
          res.data.applications
        );
      }
    } catch (error) {
      console.log(error);
      alert("Failed to load applications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  // =========================================
  // SEARCH
  // =========================================
  useEffect(() => {
    const filtered = applications.filter((item) => {
      return (
        item.student_name
          ?.toLowerCase()
          .includes(search.toLowerCase()) ||
        item.aadhar_number
          ?.includes(search) ||
        item.mobile_number
          ?.includes(search) ||
        item.admission_class
          ?.toLowerCase()
          .includes(search.toLowerCase())
      );
    });

    setFilteredApplications(filtered);
  }, [search, applications]);

  // =========================================
  // UPDATE STATUS
  // =========================================
  const updateStatus = async (id, status) => {
    try {
      const confirmUpdate = window.confirm(
        `Are you sure to change status to ${status}?`
      );

      if (!confirmUpdate) return;

      const res = await axios.put(
        `${BASE_URL}/api/admin/application/status/${id}`,
        { status }
      );

      if (res.data.success) {
        alert(res.data.message);
        fetchApplications();
      }
    } catch (error) {
      console.log(error);

      if (error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert("Failed to update status");
      }
    }
  };

  // =========================================
  // STATUS COLOR
  // =========================================
  const statusColor = (status) => {
    switch (status) {
      case "Approved":
        return "#1e7e34";

      case "Rejected":
        return "#dc3545";

      case "Waitlisted":
        return "#ff9800";

      default:
        return "#1565c0";
    }
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.heading}>
            Student Applications
          </h1>

          <p style={styles.subheading}>
            Admission Management Dashboard
          </p>
        </div>

        <div style={styles.countBox}>
          Total Applications:
          <span style={styles.count}>
            {filteredApplications.length}
          </span>
        </div>
      </div>

      {/* SEARCH */}
      <div style={styles.searchContainer}>
        <input
          type="text"
          placeholder="Search by Name / Aadhaar / Mobile / Class"
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
          style={styles.searchInput}
        />
      </div>

      {/* BODY */}
      {loading ? (
        <div style={styles.loading}>
          Loading Applications...
        </div>
      ) : filteredApplications.length === 0 ? (
        <div style={styles.noData}>
          No Applications Found
        </div>
      ) : (
        <div style={styles.grid}>
          {filteredApplications.map((item) => (
            <div
              key={item.id}
              style={styles.card}
            >
              {/* TOP */}
              <div style={styles.cardTop}>
                <div style={styles.photoBox}>
                  <img
                    src={`${BASE_URL}${item.photo_path}`}
                    alt="student"
                    style={styles.photo}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/120";
                    }}
                  />
                </div>

                <div style={styles.topDetails}>
                  <h2 style={styles.studentName}>
                    {item.student_name}
                  </h2>

                  <div style={styles.badge}>
                    {item.admission_class}
                  </div>

                  <div
                    style={{
                      ...styles.statusBadge,
                      background:
                        statusColor(item.status),
                    }}
                  >
                    {item.status}
                  </div>
                </div>
              </div>

              {/* DETAILS */}
              <div style={styles.details}>
                <Detail
                  label="Aadhaar"
                  value={item.aadhar_number}
                />

                <Detail
                  label="Gender"
                  value={item.gender}
                />

                <Detail
                  label="Category"
                  value={item.category}
                />

                <Detail
                  label="DOB"
                 /*  value={item.date_of_birth} */
                 value={
  item.date_of_birth
    ? new Date(item.date_of_birth)
        .toLocaleDateString("en-GB")
    : "-"
}
                />

                <Detail
                  label="Father"
                  value={item.father_name}
                />

                <Detail
                  label="Mother"
                  value={item.mother_name}
                />

                <Detail
                  label="Mobile"
                  value={item.mobile_number}
                />

                <Detail
                  label="WhatsApp"
                  value={item.whatsapp_number}
                />

                <Detail
                  label="Email"
                  value={item.email}
                />

                <Detail
                  label="Address"
                  value={item.permanent_address}
                />

                <Detail
                  label="Previous School"
                  value={item.previous_school}
                />

                <Detail
                  label="Previous Class"
                  value={item.previous_class}
                />

                <Detail
                  label="Applied On"
                 /*  value={new Date(
                    item.created_at
                  ).toLocaleString()} */
                  value={
  new Date(item.created_at).toLocaleString(
    "en-GB",
    {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }
  )
}
                />
              </div>

              {/* SEAT INFO */}
              <div style={styles.seatContainer}>
                <div style={styles.seatBox}>
                  <span>Total Seats</span>
                  <strong>
                    {item.seats_total}
                  </strong>
                </div>

                <div style={styles.seatBox}>
                  <span>Filled</span>
                  <strong>
                    {item.seats_filled}
                  </strong>
                </div>

                <div style={styles.seatBox}>
                  <span>Available</span>
                  <strong
                    style={{
                      color:
                        item.seats_available <= 0
                          ? "red"
                          : "green",
                    }}
                  >
                    {item.seats_available}
                  </strong>
                </div>
              </div>

              {/* ACTIONS */}
              <div style={styles.actionContainer}>
                <button
                  style={{
                    ...styles.actionBtn,
                    background: "#28a745",
                  }}
                  onClick={() =>
                    updateStatus(
                      item.id,
                      "Approved"
                    )
                  }
                >
                  Approve
                </button>

                <button
                  style={{
                    ...styles.actionBtn,
                    background: "#ff9800",
                  }}
                  onClick={() =>
                    updateStatus(
                      item.id,
                      "Waitlisted"
                    )
                  }
                >
                  Waitlist
                </button>

                <button
                  style={{
                    ...styles.actionBtn,
                    background: "#dc3545",
                  }}
                  onClick={() =>
                    updateStatus(
                      item.id,
                      "Rejected"
                    )
                  }
                >
                  Reject
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// =========================================
// DETAIL COMPONENT
// =========================================
function Detail({ label, value }) {
  return (
    <div style={styles.detailRow}>
      <span style={styles.label}>
        {label}
      </span>

      <span style={styles.value}>
        {value || "-"}
      </span>
    </div>
  );
}

// =========================================
// STYLES
// =========================================
const styles = {
  page: {
    minHeight: "100vh",
    background:
      "linear-gradient(to right, #eef2f7, #d9e4f5)",
    padding: "20px",
    fontFamily:
      "'Segoe UI', sans-serif",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "25px",
    flexWrap: "wrap",
    gap: "15px",
  },

  heading: {
    margin: 0,
    fontSize: "32px",
    color: "#0b3d91",
    fontWeight: "700",
  },

  subheading: {
    marginTop: "5px",
    color: "#555",
  },

  countBox: {
    background: "#fff",
    padding: "12px 20px",
    borderRadius: "15px",
    fontWeight: "600",
    boxShadow:
      "0 8px 20px rgba(0,0,0,0.08)",
  },

  count: {
    marginLeft: "10px",
    color: "#1565c0",
    fontSize: "20px",
  },

  searchContainer: {
    marginBottom: "25px",
  },

  searchInput: {
    width: "100%",
    maxWidth: "500px",
    padding: "14px",
    borderRadius: "12px",
    border: "none",
    outline: "none",
    fontSize: "15px",
    boxShadow:
      "0 4px 15px rgba(0,0,0,0.08)",
  },

  loading: {
    textAlign: "center",
    fontSize: "22px",
    marginTop: "100px",
    color: "#444",
  },

  noData: {
    textAlign: "center",
    fontSize: "22px",
    marginTop: "100px",
    color: "#444",
  },

  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit, minmax(360px, 1fr))",
    gap: "25px",
  },

  card: {
    background:
      "rgba(255,255,255,0.75)",
    backdropFilter: "blur(12px)",
    borderRadius: "22px",
    padding: "20px",
    boxShadow:
      "0 8px 25px rgba(0,0,0,0.12)",
    border:
      "1px solid rgba(255,255,255,0.4)",
  },

  cardTop: {
    display: "flex",
    gap: "18px",
    alignItems: "center",
    marginBottom: "18px",
  },

  photoBox: {
    width: "110px",
    height: "120px",
    borderRadius: "18px",
    overflow: "hidden",
    border: "3px solid #1565c0",
    flexShrink: 0,
     background: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  },

  photo: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
     objectPosition: "center",
    /*  objectPosition: "top center", */
      display: "block",
    /*  background: "#fff", */
  },

  topDetails: {
    flex: 1,
  },

  studentName: {
    margin: 0,
    fontSize: "24px",
    color: "#0b3d91",
  },

  badge: {
    marginTop: "10px",
    display: "inline-block",
    background: "#1565c0",
    color: "#fff",
    padding: "6px 14px",
    borderRadius: "30px",
    fontSize: "13px",
    fontWeight: "600",
  },

  statusBadge: {
    marginTop: "12px",
    color: "#fff",
    display: "inline-block",
    padding: "7px 15px",
    borderRadius: "30px",
    fontSize: "13px",
    fontWeight: "600",
  },

  details: {
    marginTop: "10px",
  },

  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    padding: "9px 0",
    borderBottom:
      "1px solid rgba(0,0,0,0.06)",
  },

  label: {
    fontWeight: "700",
    color: "#333",
  },

  value: {
    color: "#555",
    textAlign: "right",
  },

  seatContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    marginTop: "20px",
  },

  seatBox: {
    flex: 1,
    background: "#f7f9fc",
    borderRadius: "12px",
    padding: "12px",
    textAlign: "center",
    boxShadow:
      "0 4px 10px rgba(0,0,0,0.05)",
  },

  actionContainer: {
    display: "flex",
    gap: "10px",
    marginTop: "22px",
    flexWrap: "wrap",
  },

  actionBtn: {
    flex: 1,
    border: "none",
    color: "#fff",
    padding: "12px",
    borderRadius: "12px",
    cursor: "pointer",
    fontWeight: "700",
    fontSize: "14px",
  },
};